import { styled } from "@mui/material";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

export const StyledFormControlLabel = styled(FormControlLabel)`
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};

  .MuiTypography-root {
    font-size: ${({ theme }) => theme.wsc.typography.body2.fontSize};
  }

  .MuiTypography-root.Mui-disabled {
    color: ${({ theme }) => theme.wsc.palette.neutral[300]};
  }
`;

export const StyledRadioButton = styled(Radio)`
  padding: ${({ theme }) => theme.wsc.spacing[1]};

  :hover {
    background-color: transparent;

    .MuiSvgIcon-root:first-child {
      font-size: ${({ theme }) => theme.wsc.typography.header5.fontSize};
      border-width: 0.143rem;
      border-radius: ${(props) => props.theme.wsc.radius.full};
    }
  }

  .MuiSvgIcon-root:first-child {
    font-size: ${({ theme }) => theme.wsc.typography.header5.fontSize};
    border: 0.071rem solid ${({ theme }) => theme.wsc.palette.neutral[100]};
    border-radius: ${(props) => props.theme.wsc.radius.full};
    fill: none;
    box-sizing: border-box;
  }

  &.Mui-checked {
    .MuiSvgIcon-root:first-child {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[100]};
      border: none;
    }

    .MuiSvgIcon-root:nth-child(2) {
      width: auto;
      height: auto;
      fill: ${({ theme }) => theme.wsc.palette.neutral[600]};
    }

    :hover {
      .MuiSvgIcon-root:first-child {
        background-color: ${({ theme }) => theme.wsc.palette.neutral[0]};
        border: none;
      }
    }
  }

  &.Mui-disabled {
    .MuiSvgIcon-root:first-child {
      font-size: ${({ theme }) => theme.wsc.typography.header5.fontSize};
      border-color: ${({ theme }) => theme.wsc.palette.neutral[300]};
      border-radius: ${(props) => props.theme.wsc.radius.full};
      fill: none;
    }
  }

  &.Mui-checked.Mui-disabled {
    .MuiSvgIcon-root:first-child {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[300]};
      border: none;
    }
  }
`;
